import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import SimpleTable from 'core/simple-table';
import Spacer from 'core/spacer';
import useCustomMediaQuery from 'hooks/useMediaQuery';
import { useTranslations } from 'next-intl';
import VerticalCard from 'components/landing/deductibles/vertical-card';
import zip from 'utils/zip';

const Table = ({ headers, data }) => {
    if (!data || !headers) {
        return null;
    }

    const t = useTranslations('deductibles-section');
    const [isFullSize, setFullSize] = useState(false);

    useCustomMediaQuery(992, (e) => {
        setFullSize(e.matches);
    });
    useEffect(() => {
        setFullSize(window.innerWidth > 992);
    }, []);

    const tableData = [
        [t('low'), ...data.low],
        [t('moderate'), ...data.moderate],
        [t('high'), ...data.high]
    ];

    if (isFullSize) {
        return <SimpleTable headerList={headers} data={tableData} />;
    }

    return (
        <>
            <VerticalCard data={zip(data.low, headers)} cardName={t('low')} />
            <Spacer space={0.5} />
            <VerticalCard
                data={zip(data.moderate, headers)}
                cardName={t('moderate')}
            />
            <Spacer space={0.5} />
            <VerticalCard data={zip(data.high, headers)} cardName={t('high')} />
        </>
    );
};

Table.propTypes = {
    headers: PropTypes.array,
    data: PropTypes.object
};

export default Table;
